import $ from 'jquery';
import { autocomplete } from '@algolia/autocomplete-js';
import algoliasearch from 'algoliasearch';
import instantsearch from 'instantsearch.js';
import historyRouter from 'instantsearch.js/es/lib/routers/history';
import { connectSearchBox } from 'instantsearch.js/es/connectors';
import tabs from './algolia/tabsWidget.js';
import aa from 'search-insights';
import {
  configure,
  hits,
  pagination,
  searchBox
} from 'instantsearch.js/es/widgets';
import { createLocalStorageRecentSearchesPlugin } from '@algolia/autocomplete-plugin-recent-searches';
import { createQuerySuggestionsPlugin } from '@algolia/autocomplete-plugin-query-suggestions';
import { createInsightsMiddleware } from 'instantsearch.js/es/middlewares';
import {
  scrollToElement,
  getQueryParamsAsObject,
  decodeHtml
} from './lib/utilities';

// User flag
const IS_EMPLOYEE =
  window.wlAlgoliaUserParams._isEmployee == '1' ? true : false;

const formContainer = '#algolia-search-box';
const hitsContainer = '#algolia-hits';
const tabsContainer = '#algolia-tabs';
const paginationContainer = '#algolia-pagination';
const queryParams = getQueryParamsAsObject();
const appId = wlAlgolia.application_id;
const apiKey = wlAlgolia.search_api_key;
const indexName = wlAlgolia.indices.searchable_posts.name;
const suggestionIndexName =
  wlAlgolia.indices.searchable_posts.name + '_query_suggestions';
const insightsMiddleware = createInsightsMiddleware({
  insightsClient: aa
});
if ((queryParams || {}).search) setTimeout(scrollToTabs, 500);

if ($(formContainer).length > 0) {
  const filterOutPropane = (query) => {
    if (typeof query == 'object') {
      if (Object.keys(query).length === 0) return;

      if (query.search) {
        query = query.search;
      } else {
        return "";
      }
    }

    if (!query) return;

    const wordAmount = query.split(' ').length;

    // Only take out 'propane' when there are more than 1 words in query.
    return wordAmount > 1 && query.match(/propane/i)
      ? query.replace(/(propane)/gi, '').trim()
      : query.trim();
  };

  const instantSearchRouter = historyRouter();

  // Instantiate instantsearch.js
  const search = instantsearch({
    searchClient: algoliasearch(appId, apiKey),
    indexName,
    routing: {
      stateMapping: {
        stateToRoute: (uiState) => ({
          search: filterOutPropane(uiState[indexName].query),
          page: uiState[indexName].page
        }),
        routeToState: (routeState) => ({
          [indexName]: {
            query: filterOutPropane(routeState),
            page: routeState.page
          }
        })
      }
    }
  });
  search.use(insightsMiddleware);

  const widgetConfig = configure({
    hitsPerPage: 10,
    facetingAfterDistinct: true,
    highlightPreTag: '__ais-highlight__',
    highlightPostTag: '__/ais-highlight__',
    disjunctiveFacets: ['post_type_label'],
    filters: !IS_EMPLOYEE ? 'NOT perc_employees_only:true' : ''
  });
  const widgetSearchBox = searchBox({
    container: formContainer,
    placeholder: 'Search by Keyword...',
    queryHook: (query, search) => search(filterOutPropane(query)),
    poweredBy: false,
    reset: false,
    searchOnEnterKeyPressOnly: false,
    wrapInput: true,
    cssClasses: {
      submit: ['btn', 'btn--red', 'btn--block']
    },
    templates: {
      submit: `
      <span class="btn__content">
      <span class="btn__angle"></span>
      <span class="btn__text">Search</span>
      </span>
      `
    }
  });
  const widgetHits = hits({
    escapeHTML: false,
    container: hitsContainer,
    templates: {
      empty: 'No results were found for "<strong>{{query}}</strong>".',
      item: window.wp.template('instantsearch-hit')
    },
    transformItems: (items) => {
      return items.map((item) => {
        function replace_highlights_recursive(hit) {
          if (hit instanceof Object && hit.hasOwnProperty('value')) {
            hit.value = _.escape(hit.value);
            hit.value = hit.value
              .replace(/__ais-highlight__/g, '<em>')
              .replace(/__\/ais-highlight__/g, '</em>');
          } else {
            for (var key in hit) {
              hit[key] = replace_highlights_recursive(hit[key]);
            }
          }
          return hit;
        }

        item._highlightResult = replace_highlights_recursive(
          item._highlightResult
        );
        item._snippetResult = replace_highlights_recursive(item._snippetResult);
        item._highlightedTitle = decodeHtml(
          item._snippetResult.post_title.value
        );
        item._highlightedDescription = '';
        if (
          item._snippetResult['content'].value !== '' &&
          item._snippetResult.hasOwnProperty('content')
        ) {
          item._highlightedDescription = item._snippetResult['content'].value;
        } else if (
          item._snippetResult.hasOwnProperty('post_excerpt') &&
          item._snippetResult['post_excerpt'].value
        ) {
          item._highlightedDescription =
            item._snippetResult['post_excerpt'].value;
        } else if (
          item._snippetResult.hasOwnProperty('post_product_description') &&
          item._snippetResult['post_product_description'].value
        ) {
          item._highlightedDescription =
            item._snippetResult['post_product_description'].value;
        } else if (
          item._snippetResult.hasOwnProperty(
            'post_product_short_description'
          ) &&
          item._snippetResult['post_product_short_description'].value
        ) {
          item._highlightedDescription =
            item._snippetResult['post_product_short_description'].value;
        }
        item._highlightedDescription = decodeHtml(item._highlightedDescription);

        return item;
      });
    }
  });
  const widgetPagination = pagination({
    container: paginationContainer,
    templates: {
      next: '<span class="icon perc-icon-chevron-right"></span>',
      previous: '<span class="icon perc-icon-chevron-left"></span>'
    },
    maxPages: 8,
    showFirst: false,
    showLast: false,
    scrollTo: false,
    cssClasses: {
      noRefinementRoot: 'u--display-none'
    }
  });
  const widgetTabs = tabs({
    container: tabsContainer,
    facet: 'post_type_label',
    tabs: [
      {
        title: 'Pages',
        posts: ['Pages', 'Propane Products']
      },
      {
        title: 'Resource Catalog',
        posts: ['Products']
      },
      {
        title: 'News',
        posts: ['Press Releases', 'Articles', 'Videos', 'Safety Articles']
      }
    ]
  });
  let userToken = '';

  const virtualSearchBox = connectSearchBox(() => {});

  search.addWidgets([
    virtualSearchBox({}),
    widgetConfig,
    widgetHits,
    widgetPagination,
    widgetTabs
  ]);

  // Start search
  search.start();

  // Get search queryID, needed for analytics payload.
  const getQueryID = () => search.helper.lastResults.queryID;

  // Focus input
  $(formContainer).find('input').attr('type', 'search').select();

  // Set the InstantSearch index UI state from external events.
  function setInstantSearchUiState(indexUiState) {
    search.setUiState((uiState) => ({
      ...uiState,
      [indexName]: {
        ...uiState[indexName],
        page: 1,
        ...indexUiState,
        query: typeof indexUiState.query === 'string' ? indexUiState.query : ''
      }
    }));
  }
  
  function getInstantSearchUiState() {
    const uiState = instantSearchRouter.read();
    return (uiState && typeof uiState.search === 'string') ? uiState.search : '';
  }
   

  const searchPageState = getInstantSearchUiState();

  // Build URLs that InstantSearch understands.
  function getInstantSearchUrl(indexUiState) {
    return search.createURL({ [indexName]: indexUiState });
  }

  // Detect when an event is modified with a special key to let the browser
  // trigger its default behavior.
  function isModifierEvent(event) {
    const isMiddleClick = event.button === 1;

    return (
      isMiddleClick ||
      event.altKey ||
      event.ctrlKey ||
      event.metaKey ||
      event.shiftKey
    );
  }

  function onSelect({ setIsOpen, setQuery, event, query }) {
    // You want to trigger the default browser behavior if the event is modified.
    if (isModifierEvent(event)) {
      return;
    }

    setQuery(query);
    setIsOpen(false);
    setInstantSearchUiState({
      query
    });
  }

  function getItemUrl({ query }) {
    return getInstantSearchUrl({
      query
    });
  }

  function ItemWrapper({ children, query }) {
    const uiState = {
      query
    };

    return (
      <a
        className="aa-ItemLink"
        href={getInstantSearchUrl(uiState)}
        onClick={(event) => {
          if (!isModifierEvent(event)) {
            // Bypass the original link behavior if there's no event modifier
            // to set the InstantSearch UI state without reloading the page.
            event.preventDefault();
          }
        }}
      >
        {children}
      </a>
    );
  }

  const recentSearchesPlugin = createLocalStorageRecentSearchesPlugin({
    key: 'instantsearch',
    limit: 3,
    transformSource({ source }) {
      return {
        ...source,
        getItemUrl({ item }) {
          return getItemUrl({
            query: item.label
          });
        },
        onSelect({ setIsOpen, setQuery, item, event }) {
          onSelect({
            setQuery,
            setIsOpen,
            event,
            query: item.label
          });
        }
      };
    }
  });

  const querySuggestionsPlugin = createQuerySuggestionsPlugin({
    searchClient: algoliasearch(appId, apiKey),
    indexName: suggestionIndexName,
    getSearchParams() {
      return recentSearchesPlugin.data.getAlgoliaSearchParams({
        hitsPerPage: 6
      });
    },
    transformSource({ source }) {
      return {
        ...source,
        sourceId: 'querySuggestionsPlugin',
        getItemUrl({ item }) {
          return getItemUrl({
            query: item.query
          });
        },
        onSelect({ setIsOpen, setQuery, event, item }) {
          onSelect({
            setQuery,
            setIsOpen,
            event,
            query: item.query
          });
        },
        getItems(params) {
          if (!params.state.query) {
            return [];
          }

          return source.getItems(params);
        }
      };
    }
  });

  autocomplete({
    container: formContainer,
    openOnFocus: true,
    placeholder: 'Search by Keyword',
    panelPlacement: 'end',
    detachedMediaQuery: 'none',
    initialState: {
      query: typeof searchPageState === 'string' ? searchPageState : ''
    },
    onSubmit({ state }) {
      setInstantSearchUiState({ query: state.query });
    },
    onReset() {
      setInstantSearchUiState({ query: '' });
    },
    onStateChange({ prevState, state }) {
      if (prevState.query !== state.query) {
        setInstantSearchUiState({ query: state.query });
      }
    },
    plugins: [recentSearchesPlugin, querySuggestionsPlugin],
    classNames: {
      submitButton: 'btn btn--red btn--block',
      inputWrapper: 'form__field',
      input: 'form__input',
      clearButton: 'u--display-none',
      panel: 'search-page-panel'
    }
  });

  // Init Algolia analytics
  aa('init', { appId, apiKey });
  aa('getUserToken', null, (err, algoliaUserToken) => {
    if (err) return;
    userToken = algoliaUserToken;
  });

  // Add event listeners to scroll to search content
  $('html').on('submit', formContainer, scrollToTabs);
  $('html').on('click', `${paginationContainer} a`, scrollToTabs);
  $('html').on('click', `${tabsContainer} button`, scrollToTabs);
  $('html').on('click', `${hitsContainer} a.search-hit`, (event) => {
    aa('clickedObjectIDsAfterSearch', {
      userToken,
      eventName: 'Hit Clicked',
      index: indexName,
      objectIDs: [event.currentTarget.getAttribute('data-object-id')],
      positions: [
        parseInt(event.currentTarget.getAttribute('data-object-position'))
      ],
      queryID: getQueryID()
    });
  });
}

function scrollToTabs(event) {
  if (event) event.preventDefault();
  scrollToElement(tabsContainer);
}
